import httpInstances from '@/api/axiosInstance';
import type { ChartDataRange, ChartDataType } from '@/components/Chart/types/chartData';
import type { ChartType } from '@/components/Chart/types/highcharts';
import type { TemplateChartSeries } from '@/pages/Markets/MarketsComponents/types';

export async function getChartData(
  templateChartSeries: TemplateChartSeries[],
  chartType: ChartType
): Promise<ChartDataType> {
  const symbols = templateChartSeries?.map(({ symbol }) => {
    const temp = structuredClone(symbol);
    temp.overrideTime = '00:00';
    return temp;
  });
  const { data } = await httpInstances.axiosDataInstance.post(`/go/index/graph/${chartType}`, {
    symbols
  });
  return data;
}

export async function getSeasonalChartData(
  templateChartSeries: TemplateChartSeries,
  chartDataRange: ChartDataRange
): Promise<ChartDataType> {
  const symbol = structuredClone(templateChartSeries?.symbol);
  if (symbol) {
    symbol.from = chartDataRange.from;
    symbol.to = chartDataRange.to;
  }
  const { data } = await httpInstances.axiosDataInstance.post(
    `/go/index/graph/spot/seasonal`,
    symbol
  );
  return data;
}
